export function DRAWER_NAV() {
  const [w,d,param] = [window,document,location.search]
  const plugin_query = '[data-plugin="drawerNav"]'
  const init = () => {
    const drawer = d.querySelector(`${plugin_query}[role="drawer"]`)
    const trigger = d.querySelectorAll(`${plugin_query}[role="toggle"]`)
    const toggleDrawer = (stat='') => {
      let method = "toggle"
      switch(stat){
        case 'open': method = 'add'; break
        case 'close': method = 'remove'; break
      }
      d.body.classList[method]('is-drawer-active')
      drawer.classList[method]('is-active')
      Array.prototype.forEach.call(trigger, obj => {
        obj.classList[method]('is-active')
      })
    }

    // トリガーイベント登録
    Array.prototype.forEach.call(trigger, obj => {
      obj.addEventListener('click', e => {
        e.preventDefault()
        toggleDrawer()
      })
    })
    
    // メディアクエリ登録
    // const mq = w.matchMedia('(min-width: 1024px)')
    // const hundle = mq => {
    //   if(mq.matches) toggleDrawer('open')
    //   else toggleDrawer('close')
    // }
    // mq.addListener(e => hundle(e.target))
    // hundle(mq)
  }

  w.load['header'].done(()=> init())
}

export function COLLAPSE_NAV(option){
  const [w,d] = [window,document]
  const opt = $.extend(true,{
    query: '[data-plugin="collapse"]',
    trigger: '[role="parent"]',
    target: '[role="child"]',
    activeClass: 'is-active'
  },option)

  w.load['header'].done(()=> {
    const collapse = d.querySelectorAll(opt.query)
    Array.prototype.forEach.call(collapse, obj => {
      const trigger = obj.querySelector(opt.trigger)
      const target = obj.querySelector(opt.target)
      trigger.addEventListener('click', e => {
        if(e.target == trigger){
          e.preventDefault()
          obj.classList.toggle('is-active')
          target.classList.toggle('is-active')
        }
      })
    })
    
  })

}